import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import axios from "axios";
import {
  getScribeDictationList,
  getUnassignedDictations,
  updateDictationAssignment,
} from "apiHandler/actions";
import { BackButton, displayDateFormatter } from "components/helpers";
import OutsideAlerter from "components/outsideClick";
import ListTable from "components/scribe/listTable";
import { useUserData } from "components/customHooks/userDataContext";

const allStatus = [
  { label: "Total Cases Available" },
  { label: "Total Dictation worked" },
  { label: "In Scribing" },
  { label: "On Hold" },
];

const ScribeStatusList = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [status, setStatus] = useState(location.state?.label || "In Scribing");
  const [records, setRecords] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPlaying, setCurrentPlaying] = useState(null);
  const { selectedDoctor, type } = location.state;

  const userData = useUserData();

  const id_token = userData?.access_token;

  useEffect(() => {
    const source = axios.CancelToken.source();
    setRecords(null);
    if (status === "Total Cases Available") fetchTotalCases(source.token);
    else fetchRecords(status, source.token);

    // return () => {
    //   source.cancel();
    // };
    // eslint-disable-next-line
  }, [status]);
  console.log("selectedDoctor: ", selectedDoctor, location);
  const fetchTotalCases = async (token) => {
    setRecords(null);
    try {
      const payload = {
        type: "Scribe",
        search_criteria: {
          scribe_id: userData.email,
        },
      };

      if (selectedDoctor !== "all" && selectedDoctor) {
        if (type === "doctors") {
          payload.search_criteria.npi = `${selectedDoctor}`;
        } else {
          payload.search_criteria.practice_id = `${selectedDoctor}`;
        }
      }

      const totalCases = await getUnassignedDictations(
        payload,
        id_token,
        token
      );
      console.log("totalCases: ", totalCases);

      setRecords(
        totalCases.map((r) => {
          return {
            ...r,
            updated_date: displayDateFormatter(r.updated_date),
            created_date: displayDateFormatter(r.created_date),
            dos: displayDateFormatter(r.dos),
          };
        })
      );
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      }
      setRecords(null);
      console.log("error fetchTotalCases: ", error);
    }
  };

  const fetchRecords = async (status, token) => {
    setRecords(null);
    try {
      const statusMap = {
        "In Scribing": "In-Scribing",
        "Total Dictation worked": "Completed",
        "On Hold": "On-Hold",
      };
      const payload = {
        type: "Scribe",
        search_criteria: {
          scribe_id: userData.email,
          status: statusMap[status],
        },
      };
      if (selectedDoctor !== "all" && selectedDoctor) {
        if (type === "doctors") {
          payload.search_criteria.npi = `${selectedDoctor}`;
        } else {
          payload.search_criteria.practice_id = `${selectedDoctor}`;
        }
      }
      const inProgressDLList = await getScribeDictationList(
        payload,
        id_token,
        token
      );
      setRecords(
        inProgressDLList.map((r) => {
          return {
            ...r,
            updated_date: displayDateFormatter(r.updated_date),
            created_date: displayDateFormatter(r.created_date),
            dos: displayDateFormatter(r.dos),
          };
        })
      );
    } catch (error) {
      setRecords(null);
      console.log("error fetchRecords: ", error);
    }
  };

  const assignToMe = async (id) => {
    const payload = {
      type: "Scribe",
      search_criteria: {
        scribe_id: userData.email,
        dictation_id: id,
        user_name: userData.first_name + " " + userData.last_name,
      },
    };
    await updateDictationAssignment(payload, id_token);
    await fetchTotalCases();
  };

  return (
    <div className="scribe-dictation-list">
      <BackButton onClick={() => navigate(-1)} />
      <div className="status-cont">
        <OutsideAlerter onClose={() => setShowDropdown(false)}>
          <div
            className="status"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setShowDropdown(!showDropdown);
            }}
          >
            {status} ({records ? records.length : 0})
            <ExpandMoreIcon fontSize="large" />
          </div>
          {showDropdown && (
            <div className="dl-status-dropdown">
              {allStatus.map((s) => (
                <div
                  onClick={() => {
                    setStatus(s.label);
                    setShowDropdown(false);

                    navigate("", {
                      state: { ...s, selectedDoctor, type },

                      replace: true,
                    });
                  }}
                  className="dl-status-dropdown-menu"
                  key={s.label}
                >
                  {s.label}
                </div>
              ))}
            </div>
          )}
        </OutsideAlerter>
      </div>
      <ListTable
        records={records}
        currentPlaying={currentPlaying}
        setCurrentPlaying={setCurrentPlaying}
        status={status}
        assignToMe={assignToMe}
      />
    </div>
  );
};

export default ScribeStatusList;
